<script>
export default {
  name: 'ArrowDownLight',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.7955 8.7955C14.3562 9.23483 13.6438 9.23483 13.2045 8.7955L8 3.59099L2.7955 8.7955C2.35616 9.23483 1.64384 9.23483 1.20451 8.7955C0.765165 8.35616 0.765165 7.64384 1.20451 7.2045L7.2045 1.2045C7.64384 0.765165 8.35616 0.765165 8.7955 1.2045L14.7955 7.2045C15.2348 7.64384 15.2348 8.35616 14.7955 8.7955Z"
      :fill="color"
    />
  </svg>
</template>
